module.exports = __webpack_public_path__ + "static/media/30_plantilla_rec_combo_simple_cp_gaseosas_pet_237_fn.ffea79f8.png";